import { render } from "./WalletTransfers.vue?vue&type=template&id=7ad1f6d4"
import script from "./WalletTransfers.vue?vue&type=script&lang=js"
export * from "./WalletTransfers.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/WalletTransfers.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7ad1f6d4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7ad1f6d4', __exports__)) {
    api.reload('7ad1f6d4', __exports__)
  }
  
  module.hot.accept("./WalletTransfers.vue?vue&type=template&id=7ad1f6d4", () => {
    api.rerender('7ad1f6d4', render)
  })

}


export default __exports__